module.exports = __webpack_public_path__ + "static/media/COS_MAM.bd1bf0d5.png";